import { render, staticRenderFns } from "./IbxMaterials.vue?vue&type=template&id=79353724&scoped=true"
import script from "./IbxMaterials.vue?vue&type=script&lang=js"
export * from "./IbxMaterials.vue?vue&type=script&lang=js"
import style0 from "./IbxMaterials.vue?vue&type=style&index=0&id=79353724&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79353724",
  null
  
)

export default component.exports